module.exports = __webpack_public_path__ + "not-found-text/not-found-text-a7412653b1363fe9dab7fba4b1ac6abf.png";